import { alpha } from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import {
  Color,
  ColorDark,
  ColorDynamic,
  Stack,
  useSnackbarStack,
} from '@superdispatch/ui';
import { Button, TextBox } from '@superdispatch/ui-lab';
import styled from 'styled-components';
import { PostingDTO } from '../../data/dto/PostingDTO';
import { useDeleteSavedLoadMutation } from '../../data/LoadboardSavedLoadsAPI';

const Overlay = styled.div(({ theme }) => {
  const mode = theme.palette.type;
  const bgColor = mode === 'dark' ? ColorDark.White : Color.White;
  return `
  position: absolute;
  left: -4px;
  width: 100%;
  height: 100%;
  z-index: 1;

  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${alpha(bgColor, 0.6)};
`;
});

const Content = styled.div`
  background-color: ${ColorDynamic.White};
  box-shadow: ${ColorDynamic.White} 0 0 20px 20px;
`;

interface Props {
  posting: PostingDTO;
}

export function UnpostedSavedLoadOverlay({ posting }: Props) {
  const { addSnackbar } = useSnackbarStack();
  const deleteLoadMutation = useDeleteSavedLoadMutation({
    onSuccess: () => {
      addSnackbar('Load removed from Saved', { variant: 'success' });
    },
    onError: (error) => {
      addSnackbar(error.message || 'Failed to delete saved load', {
        variant: 'error',
      });
    },
  });

  if (!posting.is_saved || !posting.load.unposted_at) {
    return null;
  }

  return (
    <Overlay
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <Content>
        <Stack align="center">
          <TextBox variant="heading-4">
            This load is no longer available
          </TextBox>
          <Button
            startIcon={<Delete />}
            variant="neutral"
            onClick={() => {
              deleteLoadMutation.mutate(posting.load.guid);
            }}
          >
            Remove
          </Button>
        </Stack>
      </Content>
    </Overlay>
  );
}
